import { Component, Inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IGallery } from '@core/models/modals';
import { IHotelImage } from '@core/models/hotel';
import { MbDialogRef, MB_DIALOG_DATA, MbDialogBody, MbIcon, MbStarsRating } from '@am/moebius';
import { DialogWrapperComponent } from '@modals/dialog-wrapper/dialog-wrapper.component';
import { ReqService } from '@core/services';
import { SliderComponent } from '@commons/slider/slider.component';

@Component({
  selector: 'app-modal-gallery',
  standalone: true,
  imports: [CommonModule, MbDialogBody, MbIcon, MbStarsRating, SliderComponent],
  templateUrl: './gallery.component.html',
  styleUrls: ['./gallery.component.scss'],
})
export class ModalGalleryComponent extends DialogWrapperComponent implements OnInit {
  public images: IHotelImage[];
  public isExperts: boolean;

  constructor(
    private dialogRef: MbDialogRef<ModalGalleryComponent>,
    @Inject(ReqService) private reqService: ReqService,
    @Inject(MB_DIALOG_DATA) public dialogData: IGallery,
  ) {
    super();
  }

  ngOnInit() {
    super.ngOnInit();
    this.images = [...this.dialogData.hotelStatic.images];
    this.isExperts = this.reqService.isExperts();
  }

  public closeDialog() {
    this.dialogRef.close();
  }

}
